import OrderList from 'components/OrderList';

function OrderHistoryView() {
  return (
    <div className='orderHistoryView-root hidden-content appear overflow-y-scroll h-full md:p-4 md:max-w-[600px] md:m-auto'>
      <OrderList limit={15} limitDays={30} />
    </div>
  );
}

export default OrderHistoryView;
